export function dailyDigestBuilderForUI(data) {
  return {
    notificationSettingId: data.NotificationSettingID,
    notificationSetting: data.NotificationSetting,
    description: data.Description,
    isEnabled: data.IsEnabled,
  };
}
